import {useTranslation} from 'react-i18next';
import {Box, FormControl, Select, MenuItem} from '@mui/material';
import './LanguageSwitch.css';

type LanguageCode = 'en' | 'es' | 'fr' | 'pt';

const LANGUAGE_OPTIONS: Array<{
  code: LanguageCode;
  label: string;
  flag: string;
}> = [
  {code: 'en', label: 'ENG', flag: '🇺🇸'},
  {code: 'es', label: 'ESP', flag: '🇲🇽'},
  {code: 'fr', label: 'FRA', flag: '🇫🇷'},
  {code: 'pt', label: 'POR', flag: '🇧🇷'},
];

/**
 * LanguageSwitch Component
 * Dropdown select for switching between supported languages (en, es, fr, pt)
 * Language selection is persisted to localStorage and synced with i18n
 */
export const LanguageSwitch = () => {
  const {i18n} = useTranslation();

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language as LanguageCode);
  };

  return (
    <Box className="language-switch" data-testid="language-switch">
      <FormControl size="small" className="language-switch__form">
        <Select
          value={i18n.language}
          onChange={event => handleLanguageChange(event.target.value)}
          className="language-switch__select"
          data-testid="language-switch-select"
          aria-label="Select language"
        >
          {LANGUAGE_OPTIONS.map(({code, label, flag}) => (
            <MenuItem
              key={code}
              value={code}
              data-testid={`language-switch-option-${code}`}
              className="language-switch__option"
            >
              <span className="language-switch__option-flag">{flag}</span>
              <span className="language-switch__option-label">{label}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSwitch;
